import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ImportStatus } from '@synergy/models';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';

const ImportStatusOptions: SelectOption[] = Object.keys(ImportStatus)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .filter(key => (ImportStatus as any)[key] !== ImportStatus.Publishing)
    .map(key => {
        return {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value: (ImportStatus as any)[key],
            displayValue: (
                <FormattedMessage id={'app.importStatus.' + key.charAt(0).toLocaleLowerCase() + key.slice(1)} />
            ),
        };
    });

export const ImportStatusFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (value?: string) => {
        filter.delete(FilterParams.Status);
        if (value) {
            filter.set(FilterParams.Status, value);
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.Status, typeValue => {
        const type = ImportStatusOptions.find(option => option.value === typeValue);
        return type?.displayValue;
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name="type"
            label={<FormattedMessage id="app.label.status" />}
            fullWidth={true}
            value={filter.get(FilterParams.Status)}
            onValueChange={onSelected}
            options={ImportStatusOptions}
            noSorting={true}
        />
    );
};
